/* eslint-disable */
import pageContext from '@bingads-webui-static-legacy/page-context';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
function addTargetedTriggerFunc(triggerId, featureName, areaName, targetId) {
  var _userVoice = window.UserVoice || [];
  _userVoice.push(['identify', {
    id: pageContext.CurrentUser.Id,
    account: {
      id: pageContext.CurrentAccount.Id,
      name: pageContext.CurrentAccount.AccountNumber
    }
  }]);
  _userVoice.push(['set', {
    ticket_custom_fields: {
      'UserAgent': navigator.userAgent,
      'Feature': featureName,
      'FeatureArea': areaName,
      'URL': window.location.href,
      'AccountNumber': pageContext.CurrentAccount.AccountNumber,
      'AccountName': pageContext.CurrentAccount.Name,
      'AccountID': pageContext.CurrentAccount.Id,
      'CustomerID': pageContext.CurrentCustomer.Id,
      'CustomerName': pageContext.CurrentCustomer.Name,
      'PageHTML': ''
    },
    smartvote_enabled: false,
    target: targetId,
    screenshot_enabled: false,
    strings: {
      contact_menu_label: i18n.getString('UserVoice_WidgetText_ContactMenuLabel'),
      contact_title: i18n.getString('UserVoice_WidgetText_ContactTitle'),
      contact_message_placeholder: i18n.getString('UserVoice_WidgetText_ContactMessagePlaceholder'),
      contact_skip_instant_answers_button: i18n.getString('UserVoice_WidgetText_ContactSkipInstantAnswersButton'),
      contact_details_title: i18n.getString('UserVoice_WidgetText_ContactDetailsTitle'),
      contact_submit_button: i18n.getString('UserVoice_WidgetText_ContactSubmitButton'),
      contact_success_title: i18n.getString('UserVoice_WidgetText_ContactSuccessTitle'),
      contact_success_body: i18n.getString('UserVoice_WidgetText_ContactSuccessBody'),
      email_address_label: i18n.getString('UserVoice_WidgetText_EmailAddressLabel'),
      email_address_placeholder: i18n.getString('UserVoice_WidgetText_EmailAddressPlaceholder')
    }
  }]);
  _userVoice.push(['addTrigger', triggerId, {
    mode: 'contact'
  }]);
}
;
function addTriggerFunc(triggerId, featureName, areaName) {
  addTargetedTriggerFunc(triggerId, featureName, areaName, 'self');
}
;
export default {
  addTrigger: addTriggerFunc,
  addTargetedTrigger: addTargetedTriggerFunc
};

